export default "__VITE_ASSET__f56ab2a3__"